import { API, API_POST } from "../../Config";

export const handleUpdateProduct = (payload) => {
  const formData = new FormData();

  Array.from(payload.image).forEach((img, idx) => {
    formData.append(`p_images[${idx}]`, img);
  });
  if (payload.remove_photos) {
    formData.append("remove_photos", payload.remove_photos);
  }
  formData.append("product_name", payload.product_name);
  formData.append("actual_price", payload.actual_price);
  formData.append("discount_price", payload.discount_price);
  formData.append("available_stock", payload.available_stock);
  formData.append("description", payload.description);
  formData.append("id", payload.id);

  return API_POST(API.editProduct, formData);
};
